import { render, staticRenderFns } from "./ViewContent.vue?vue&type=template&id=6400a8d2&scoped=true"
import script from "./ViewContent.vue?vue&type=script&lang=js"
export * from "./ViewContent.vue?vue&type=script&lang=js"
import style0 from "./ViewContent.vue?vue&type=style&index=0&id=6400a8d2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6400a8d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6400a8d2')) {
      api.createRecord('6400a8d2', component.options)
    } else {
      api.reload('6400a8d2', component.options)
    }
    module.hot.accept("./ViewContent.vue?vue&type=template&id=6400a8d2&scoped=true", function () {
      api.rerender('6400a8d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/news/ViewContent.vue"
export default component.exports